import React, { useEffect, useContext, useState } from "react";
import {
  StyleSheet,
  View,
  Image,
  TouchableOpacity,
  Dimensions,
} from "react-native";
import { InputBox, IconButton, context } from "../accessories/accessories.js";
import {
  FormatPhoneLogin,
  handleAPI,
  handleOpenURL,
  getQueryString,
  log,
  getQueryStringURL,
  updateWebURL,
  handleTrackGA4Events,
  handleGetButtonText,
  handleGetBrowserName,
  queryStringToObject,
} from "../accessories/CommonFunctions.js";
import CustomText from "../accessories/CustomText.js";

import FontAwesome from "react-native-vector-icons/FontAwesome";
import Checkbox from "expo-checkbox";
import AsyncStorage from "@react-native-async-storage/async-storage";
import ScrollContainer from "../accessories/ScrollContainer.js";
import { web, android } from "../accessories/Platform.js";
import { REDIRECT_URL } from "@env";
import ArrowSpinner from "../accessories/ArrowSpinner.js";

//const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
//const isAndroid = /Android/.test(navigator.userAgent);
const Signup = ({ navigation, route }) => {
  let isMobileWeb = Dimensions.get("window").width <= 480;
  const { contextDetails, setContextDetails } = useContext(context); //Get value from context
  const { params } = route;
  const userName = params ? params.userName || "" : "";
  const { deviceId = "" } = params || {};
  const loginFrom = getQueryString("To", "siteLogin") || "siteLogin";
  let email = "",
    cellPhone = "";
  if (userName.indexOf("@") === -1 && Number(userName) > 0) {
    cellPhone = userName
      .replaceAll("-", "")
      .replaceAll("(", "")
      .replaceAll(")", "")
      .replaceAll(" ", "");
  } else {
    email = userName;
  }
  const [errorMsg, setErrormsg] = useState({
    text: "",
    color: "red",
  });

  const [emailSentTo, setEmailSentTo] = useState(null);
  const [currentPage, setCurrentpage] = useState("signUp"); //signUp
  const [isRemember, setIsRemember] = useState(false);
  const [userType, setUserType] = useState({
    mortgageEmployee: false,
    borrower: false,
    vendor: false,
  });
  const [newPassword, setNewPassword] = useState({
    password: "",
    confirmPassword: "",
  });
  const [newIsPasswordSecure, setNewIsPasswordSecure] = useState({
    password: !false,
    confirmPassword: !false,
  });
  const [PasswordMisMatch, setPasswordMisMatch] = useState("");
  const [newPasswordMessage, setnewPasswordMessage] = useState({
    passwordMsg: "",
    confirmPasswordMsg: "",
  });
  const [headerText, setHeaderText] = useState(
    `~~~Your ${
      userName.indexOf("@") === -1 ? "Cell Phone" : "Email Address"
    } is not recognized. To create an account, enter your contact information or click the Back link to try again`
  );
  const [signUpDetails, setSignUpDetails] = React.useState({
    firstName: "",
    lastName: "",
    cellPhone: cellPhone,
    formatedCellPhone: FormatPhoneLogin(cellPhone),
    email: email,
    enteredAccessCode: "",
  });
  const [processingStatus, setProcessingStatus] = useState(null);
  const [validateSignUp, setValidateSignUp] = React.useState({
    firstName: false,
    lastName: false,
    cellPhone: false,
    email: false,
  });
  const [webPageURL, setWebPageURL] = useState(null);
  const [accesscodeWarningMsg, setAccesscodeWarningMsg] = useState(null);
  const handleGetRouteName = () => {
    let Route = "";
    try {
      Route = window.parent.getQuerystring("Route");
    } catch (error) {
      try {
        Route = getQueryString("Route");
      } catch (error) {
        Route = "";
      }
    }
    return Route;
  };
  const [Route, setRoute] = useState(handleGetRouteName());
  useEffect(() => {
    if (
      ["securedoc", "loanapp", "chat", "ratequote", "loginverify"].indexOf(
        loginFrom
      ) > -1
    ) {
      const timer = setInterval(() => {
        try {
          let obj = window.parent.document.getElementById("iframeLogin"),
            height = obj.contentWindow.document.body.scrollHeight;
          if (parseInt(obj.style.height.replace("px", "")) < height)
            try {
              window.parent?.resizeLoginIframe();
            } catch (error) {}
        } catch (error) {}
      }, 500);
      return () => clearInterval(timer);
    }
  }, []);

  const handleSetStoredCredential = (signDetails) => {
    if (isRemember) {
      let { WebLoginId, firstName, lastName, cellPhone, email, URL, UserType } =
          signDetails,
        date = new Date();
      date.setDate(date.getDate() + 30);
      let objectToStore = {
        WebLoginId: WebLoginId,
        UserDisplayName: `${firstName} ${lastName}`,
        URL: URL, // "BorrowerWelcome",
        UserName: email || cellPhone,
        AutoRedirectExpiryDate: date, //getExpireDate(60), //in Minutes
        AutoRedirect: true,
        DeviceId: deviceId,
        UserType: UserType,
        //====
        // UserWebLoginId: WebLoginId,
        // UserRememberDevice: 1,
        // UserRedirectURL: URL,
      };
      AsyncStorage.removeItem("Credentials");
      AsyncStorage.setItem(
        "Credentials",
        JSON.stringify(objectToStore || null)
      );
    }
  };
  const getExpireDate = (expireInMinutes) => {
    const now = new Date();
    let expireTime = new Date(now);
    expireTime.setMinutes(now.getMinutes() + expireInMinutes);
    return expireTime.getTime();
  };
  // const navigate = (path, option) => {
  //   navigation.navigate(path, option || {});
  // };
  const navigate = async (navigateTo, navigateDetails) => {
    let details = { ...navigateDetails, navigation: navigation };
    setContextDetails((prevContextDetails) => {
      return { ...prevContextDetails, ...details };
    });
    if (navigateTo === "DashBoard") {
      let url = await updateWebURL(
        { ...navigateDetails, Path: navigateTo },
        true
      );
      window.top.location.href = `${window.location.origin}${
        window.location.host === "localhost:19006"
          ? ""
          : "/GoDirect/index.html?"
      }${url}`;
    } else {
      updateWebURL({ ...navigateDetails, Path: navigateTo });
      (navigation || props["navigation"]).navigate(navigateTo, navigateDetails); // Sample ===> "signUp",{}
    }
  };
  const navigateURL = (navigateTo, navigateDetails, SessionID) => {
    if (!navigateDetails) {
      navigateDetails = {};
    }
    let details = { ...navigateDetails, navigation: navigation };
    setContextDetails((prevContextDetails) => {
      return { ...prevContextDetails, ...details };
    });

    //let url = await updateWebURL(
    //  let url = updateWebURL({ ...navigateDetails, Path: navigateTo }, true);
    let url = "Path=" + navigateTo + "&SessionId=" + SessionID;
    let redirectURL = `${window.location.origin}${
      window.location.host === "localhost:19006" ? "" : "/GoDirect/index.html?"
    }${url}`;
    return redirectURL;
  };
  const handleClearState = (time) => {
    if (time === 0) {
      handleResetState();
    } else {
      setTimeout(() => {
        handleResetState();
      }, 3000);
    }
  };
  const handleResetState = () => {
    setProcessingStatus(null);
    setErrormsg({ ...errorMsg, text: "" });
    setEmailSentTo("");
    setCurrentpage("signUp");
    setUserType({
      mortgageEmployee: false,
      borrower: false,
      vendor: false,
    });
    setNewPassword({
      password: "",
      confirmPassword: "",
    });
    setNewIsPasswordSecure({
      password: false,
      confirmPassword: false,
    });
    setnewPasswordMessage({
      passwordMsg: "",
      confirmPasswordMsg: "",
    });
    setHeaderText(
      `~~~Your ${
        userName.indexOf("@") === -1 ? "Cell Phone" : "Email Address"
      } is not recognized. To create an account, enter your contact information or click the Back link to try again`
    );
    setSignUpDetails({
      firstName: "",
      lastName: "",
      cellPhone: cellPhone,
      formatedCellPhone: FormatPhoneLogin(cellPhone),
      email: email,
      enteredAccessCode: "",
    });
  };
  const handleChange = (event) => {
    let { name, value, isFormat } = event,
      obj = { [name]: value };
    // if (name === "cellPhone" && value !== "") {
    //   value = value
    //     .replaceAll("-", "")
    //     .replaceAll("(", "")
    //     .replaceAll(")", "")
    //     .replaceAll(" ", "");
    // }
    if (isFormat)
      obj = { [name]: value, formatedCellPhone: FormatPhoneLogin(value) };
    else if (name === "cellPhone")
      obj = { [name]: value, formatedCellPhone: value };

    setSignUpDetails({ ...signUpDetails, ...obj });
  };
  const handleValidateAccessCode = async () => {
    // console.log(signUpDetails);
    setAccesscodeWarningMsg("");

    if (
      Number(signUpDetails["AccessCode"]) ===
      Number(signUpDetails["enteredAccessCode"])
    ) {
      setProcessingStatus("validating");
      switch (loginFrom) {
        case "ratequote":
          await handleStoreCampaignDetails(201, "Rate Quote", 11);
          break;
        case "loanapp":
          await handleStoreCampaignDetails(202, "Loan Application", 14);
          break;
        case "securedoc":
          await handleStoreCampaignDetails(204, "Document Upload", 15);
          break;
        case "ratewizard":
          if (getQueryString("RateOptions", "0") == 1)
            await handleStoreCampaignDetails(501, "Rate  Options View", 11);
          else if (getQueryString("LockThisRate", "0") == 1)
            await handleStoreCampaignDetails(
              502,
              "Lock This Interest Rate",
              1106
            );
          else if (getQueryString("CustomizeOptions", "0") == 1)
            await handleStoreCampaignDetails(503, "Customize Options", 1105);
          if (
            getQueryString("RateOptions", "0") != 1 &&
            getQueryString("LockThisRate", "0") != 1 &&
            getQueryString("CustomizeOptions", "0") != 1
          ) {
            if (getQueryString("From", "") == "DirectWareHome")
              await handleStoreCampaignDetails(302, "DirectWare Home", 1052);
            else if (
              getQueryString("From", "") == "LoanOfficerWebsite" &&
              getQueryString("Campaign", "") == "TrackTheseRates"
            )
              await handleStoreCampaignDetails(
                901,
                "Track Interest Rates",
                1131
              );
            else if (getQueryString("From", "") == "LoanOfficerWebsite")
              await handleStoreCampaignDetails(
                301,
                "Loan Officer Website",
                1071
              );
            else await handleStoreCampaignDetails(300, "Rate Wizard", 1045);
          }
          break;
        default:
          await handleStoreCampaignDetails(118, "Login Creation", -1); //-1 will be the flage for storing campaign
          break;
      }
      await handleLogDWCallToActionEventParent("Login");
      handleLogGAEventPasscode();
      handleUpdateUserEmailInCTA(signUpDetails["email"]);

      setContextDetails((prevContextDetails) => {
        return { ...prevContextDetails, Email: signUpDetails["email"] };
      });

      if (window.parent !== null) {
        if (signUpDetails["CampaignPage"] === 1) {
          window.parent.StoreCampaignDetails(true);
          window.parent.GloWebLoginId = signUpDetails["WebLoginId"];
          window.parent.GloWebLoginIdModal = signUpDetails["WebLoginId"];
          if (window.parent.GloStayInPage == 1) {
            handleClearState();
            window.parent.document.querySelector(
              "#divCampaignModalMsg"
            ).style.display = "block";
            window.parent.fnCloseCampignModal();
            return;
          }
          if (
            window.parent.GloStayInPage == 0 &&
            window.parent.GloProceedtoWelcome == 1
          ) {
            window.parent.fnCloseCampignModal();
            handleClearState();
            // let urltogo = `../../../BorrowerLanding/Presentation/Webforms/BorrowerWelcome.aspx?SessionId=${signUpDetails["SessionId"]}&To=${loginFrom}`;

            let urltogo = `${window.location.origin}/GoDirect/index.html?Path=DashBoard&SessionId=${signUpDetails["SessionId"]}`;

            if (
              signUpDetails["LoanOfficerId"] == 1 ||
              signUpDetails["LoanOfficerId"] == 2099
            ) {
              //navigate("DashBoard", params);
              urltogo = navigateURL(
                "DashBoard",
                params,
                signUpDetails["SessionId"]
              );
            }
            let signDetails = { ...signUpDetails, URL: urltogo };
            handleSetStoredCredential(signDetails);

            try {
              window.parent.location.href = urltogo;
            } catch (e) {
              window.location.href = urltogo;
            }
            return;
          }
          return;
        }
      }
      //Store Campaign Details

      let StartLoanApp = Number(getQueryString("StartLoanApp", "0") || 0);
      if (loginFrom == "securedoc") {
        let url = signUpDetails["URL"];
        url += "&loanOfficerId=" + signUpDetails["LoanOfficerId"];
        handleSetStoredCredential(signUpDetails);
        try {
          window.parent.location.href = url;
        } catch (e) {
          window.location.href = url;
        }

        return;
      }
      if (loginFrom == "ratewizard" && StartLoanApp === 0) {
        handleAssociateLoanId(signUpDetails["SessionId"], signUpDetails["URL"]);
        handleRateOptionsLogin();
        return;
      }
      if (loginFrom === "ratequote") {
        setErrormsg({
          text: "Please wait while we are Creating the loan with this scenario...",
          color: "#999",
        });
        let LoginXML = signUpDetails["rateQuoteXML"];

        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(LoginXML, "text/xml");
        LoginXML = xmlDoc.documentElement;
        LoginXML = LoginXML.querySelectorAll("Component row");
        LoginXML.forEach(function (row) {
          row.setAttribute("UserEmailID", signUpDetails["email"]);
        });

        window.parent.document.querySelector("#hdnWebLoginId").value =
          signUpDetails["WebLoginId"];
        window.parent.$LIXD = LoginXML || "";
        window.parent.fnCreateSessionNew();
        window.parent.fnCreateLoanAndLock_publicpage_New(
          signUpDetails["GatherId"]
        );
        return;
      }
      if (loginFrom === "chat") {
        handleChatProcess();
        return;
      }
      if (loginFrom == "ratewizard") {
        let url = signUpDetails["URL"];
        handleSetStoredCredential(signUpDetails);
        try {
          window.parent.location.href = url;
        } catch (e) {
          window.location.href = url;
        }

        return;
      }
      if (loginFrom === "securedoc" || loginFrom === "loanapp") {
        let { URL, SessionId } = signUpDetails;
        loginFrom === "loanapp" && handleAssociateLoanId(SessionId, URL);
        handleSetStoredCredential(signUpDetails);

        try {
          window.parent.location.href = URL;
        } catch (e) {
          window.location.href = URL;
        }
        return;
      }

      if (loginFrom === "employment") {
        handleAPI({
          name: "CreateLoginAccountForApplicant",
          params: { GatherId: signUpDetails["GatherId"] },
        })
          .then((WebLoginId) => {
            handleLogGAEventPasscode();
            let JobPos = getQueryString("JobPos", ""),
              url =
                "../../../Login/presentation/webforms/Applyjob.aspx?WebLogID=" +
                WebLoginId +
                "&JobPos=" +
                JobPos;
            try {
              window.parent.location.href = url;
            } catch (e) {
              window.location.href = url;
            }
          })
          .catch((e) =>
            log("Error from CreateLoginAccountForApplicant ====>", e)
          );

        return;
      }
      if (loginFrom === "loginverify") {
        let strPackage =
            window.parent.document.querySelector("#hdnPackage").value,
          RefType = window.parent.document.querySelector("#hdntype").value,
          loginverifyurl = "";
        if (RefType == "plaid") {
          loginverifyurl = `../../../BorrowerApplication/presentation/webforms/BankVerification.aspx?SessionId=${signUpDetails["SessionId"]}&uid=${strPackage}`;
          handleSetStoredCredential({ ...signUpDetails, URL: loginverifyurl });

          try {
            window.parent.location.href = loginverifyurl;
          } catch (e) {
            window.location.href = loginverifyurl;
          }
        }
        return;
      }
      if (["RunScenario", "Ratesheetsignin"].includes(loginFrom)) {
        handleSaveUseType(false, signUpDetails, true);
        return false;
      }
      //
      setHeaderText("~~~Set a password or skip and login.");
      setCurrentpage("loginOption");
    } else {
      setErrormsg({
        ...errorMsg,
        text: "Invalid Access Code.",
      });
    }
  };
  const handleChatProcess = (logDetails) => {
    let ChatWithId = getQueryString("ChatWithId", 0),
      url = "";
    if (ChatWithId == "" || ChatWithId == null || ChatWithId == undefined)
      ChatWithId = 0;

    if (ChatWithId == 0)
      url = `../../../ChatSession/Presentation/Webforms/ChatMenu.aspx?SessionId=${signUpDetails["SessionId"]}&zid=${signUpDetails["WebLoginId"]}`;
    else
      url = `../../../ChatSession/Presentation/Webforms/ChatMenu.aspx?SessionId=${signUpDetails["SessionId"]}&zid=${signUpDetails["WebLoginId"]}&ChatWithId=${ChatWithId}`;
    if (isRemember) handleSetStoredCredential({ ...logDetails, URL: url });
    try {
      window.parent.location.href = url;
    } catch (e) {
      window.location.href = url;
    }
  };
  const handleRateOptionsLogin = () => {
    let From = getQueryString("From", ""),
      RateQuoteId = getQueryString("RateQuoteId", ""),
      PublicRateQuoteId = getQueryString("PublicRateQuoteId", ""),
      StartLoanApp = getQueryString("StartLoanApp", "0"),
      RateOptions = getQueryString("RateOptions", "0"),
      LockThisRate = getQueryString("LockThisRate", "0"),
      HomePage = getQueryString("HomePage", "0"),
      URL = "",
      { SessionId, GatherId, LoanOfficerId } = signUpDetails;

    if (!From) From = "";
    if (!RateQuoteId) RateQuoteId = "0";
    if (!PublicRateQuoteId) PublicRateQuoteId = "0";
    try {
      if (!LoanOfficerId)
        LoanOfficerId =
          window.parent.document.getElementById("spnUserInfo").attributes.empnum
            .value || "1";
    } catch (e) {}

    if (!LoanOfficerId) LoanOfficerId = "1";

    if (StartLoanApp == 1) {
      //URL = `../../../BorrowerLanding/Presentation/Webforms/BorrowerWelcome.aspx?SessionId=${SessionId}&StartLoanApp=1&To=${loginFrom}`;

      URL = `${window.location.origin}/GoDirect/index.html?Path=DashBoard&SessionId=${SessionId}&StartLoanApp=1`;

      if (
        signUpDetails["LoanOfficerId"] == 1 ||
        signUpDetails["LoanOfficerId"] == 2099
      ) {
        //navigate("DashBoard", params);
        URL = navigateURL("DashBoard", params, SessionId);
      }
    } else {
      if (HomePage == 1) {
        try {
          window.parent.glo_SessionId = SessionId;
          window.parent.fnCloseCampignModal();
          if (RateOptions == 1) {
            window.parent.fnTriggerFrameOptions(1);
          }
          if (LockThisRate == 1) {
            window.parent.fnTriggerFrameOptions(2);
          }
          return false;
        } catch (e) {
          if (window.parent.ParentPage === "NewLoPage") {
            try {
              window.parent.glo_SessionId = SessionId;
              //window.parent.fnCloseCampignModal();
              //window.parent.glo_CloseLoginPage = true;
              // if (RateOptions == 1) {
              //   window.parent.fnTriggerFrameOptions(1);
              // }
              if (LockThisRate == 1) {
                window?.parent?.document
                  ?.getElementById("btnLockThisIntRate")
                  ?.click();
              }
              return false;
            } catch (e) {}
          }
          return false;
        }
      }

      URL = `../../../rates/rates-wizard.php?SessionId=${SessionId}&GatherId=${GatherId}&From=${From}&LoanOfficerId=${LoanOfficerId}&${
        PublicRateQuoteId > 0
          ? `PublicRateQuoteId=${PublicRateQuoteId}`
          : `RateQuoteId=${RateQuoteId}`
      }`;
    }
    //From=LoanOfficerWebsite
    if (
      URL.indexOf("BorrowerWelcome") !== -1 &&
      (signUpDetails["LoanOfficerId"] == 1 ||
        signUpDetails["LoanOfficerId"] == 2099)
    ) {
      navigate("DashBoard", params);
    } else {
      try {
        window.parent.location.href = URL;
      } catch (e) {
        window.location.href = URL;
      }
    }
  };
  const handleSubmit = async () => {
    let { firstName, lastName, cellPhone, email } = signUpDetails;
    if (
      firstName === "" ||
      lastName === "" ||
      cellPhone === "" ||
      email === ""
    ) {
      setValidateSignUp({
        ...validateSignUp,
        ...{
          firstName: firstName === "",
          lastName: lastName === "",
          cellPhone: cellPhone === "",
          email: email === "",
        },
      });
      setErrormsg({
        text: "Please make an entry in all required fields.",
        color: "#999",
      });
      return false;
    } else {
      setErrormsg({
        text: "",
      });
    }

    let LoanOfficerId = signUpDetails["LoanOfficerId"] || 0,
      OrgUrl = window.top.document.location.href;
    if (!OrgUrl) OrgUrl = "";
    // if (loginFrom === "employment" || loginFrom === "esign")
    //   OrgUrl = OrgUrl.split("?")[0];
    if (loginFrom === "Ratesheetsignin") OrgUrl = OrgUrl.replaceAll("#", "");
    OrgUrl = OrgUrl.replaceAll("&", "%26");
    setProcessingStatus("Submit");
    let obj = `<root><row IsValidCode="0" FName="${firstName}" LName="${lastName}" CellPhone="${cellPhone}" EmailAddress="${email}" ShortCode="" Utype="" WhatFor="" LoanOfficerId="${LoanOfficerId}" OrgUrl="${OrgUrl}"/></root>`;
    console.log(obj);
    await handleAPI({
      name: "CheckSignUpDetailsLoginWeb",
      params: { CustDetails: obj },
    }).then(async (response) => {
      response = JSON.parse(response)["Table"][0];
      response = { ...signUpDetails, ...response };
      setSignUpDetails(response);
      if (window.parent) {
        window.parent.GatherId = response["GatherId"];
      }
      if (response["CampaignPage"] === 1) {
        setHeaderText("~~~Select your preferred contact method.");
        setCurrentpage("ContactMethod");
      } else {
        handleCreateAccessCode(response, undefined, -1);
      }
    });
  };
  const handleGetLoanOfficerId = () => {
    let LoanOfficerId = 0;
    if (
      loginFrom == "securedoc" ||
      loginFrom == "loanapp" ||
      loginFrom == "ratequote" ||
      loginFrom == "ratewizard"
    ) {
      try {
        LoanOfficerId = window.parent.getQueryString("empnum", "");
        if (
          LoanOfficerId == 0 ||
          LoanOfficerId == null ||
          LoanOfficerId == "" ||
          LoanOfficerId == undefined
        ) {
          LoanOfficerId = window.parent.getQueryString("loanofficer", "");
        }

        if (
          LoanOfficerId == 0 ||
          LoanOfficerId == null ||
          LoanOfficerId == "" ||
          LoanOfficerId == undefined
        ) {
          LoanOfficerId = getQueryString("loanofficer", "");
        }
      } catch (e) {
        if (
          LoanOfficerId == 0 ||
          LoanOfficerId == null ||
          LoanOfficerId == "" ||
          LoanOfficerId == undefined
        ) {
          LoanOfficerId = getQueryString("loanofficer", "");
        }
      }

      if (loginFrom == "ratewizard") {
        LoanOfficerId = getQueryString("loanofficer", "");
      }
      try {
        if (
          LoanOfficerId == 0 ||
          LoanOfficerId == null ||
          LoanOfficerId == "" ||
          LoanOfficerId == undefined
        ) {
          LoanOfficerId =
            window.parent.document.getElementById("spnUserInfo").attributes
              .empnum.value;
        }
      } catch (e) {}

      try {
        if (
          LoanOfficerId == 0 ||
          LoanOfficerId == null ||
          LoanOfficerId == "" ||
          LoanOfficerId == undefined
        ) {
          LoanOfficerId = window.parent.LoanOfficerId;
        }
      } catch (e) {}

      if (
        LoanOfficerId == 0 ||
        LoanOfficerId == null ||
        LoanOfficerId == "" ||
        LoanOfficerId == undefined
      )
        LoanOfficerId = "1";
    }
    return Number(LoanOfficerId) || 0;
  };
  const handleCreateWebLoginforChat = (signDetails) => {
    let { GatherId } = signDetails;
    handleAPI({
      name: "CreateWebLoginforChatWeb",
      params: { GatherId: GatherId },
    })
      .then((response) => {
        let WebLoginId = response;
        if (WebLoginId > 0) {
          setSignUpDetails({ ...signDetails, WebLoginId: WebLoginId });
          if (loginFrom !== "ratequote")
            handleAPI({
              name: "CreateSessionWrapper",
              params: { WebLoginId: WebLoginId },
            })
              .then((response) => {
                response = response.split("~");
                let SessionId = response[0],
                  ChatWithId = getQueryString("ChatWithId", 0),
                  url = "";
                if (
                  ChatWithId == "" ||
                  ChatWithId == null ||
                  ChatWithId == undefined
                )
                  ChatWithId = 0;

                if (ChatWithId == 0)
                  url = `../../../ChatSession/Presentation/Webforms/ChatMenu.aspx?SessionId=${SessionId}&zid=${WebLoginId}`;
                else
                  url = `../../../ChatSession/Presentation/Webforms/ChatMenu.aspx?SessionId=${SessionId}&zid=${WebLoginId}&ChatWithId=${ChatWithId}`;
                if (isRemember)
                  handleSetStoredCredential({ ...signDetails, URL: url });
                try {
                  window.parent.location.href = url;
                } catch (e) {
                  window.location.href = url;
                }
              })
              .catch((e) => log("Error form ====> CreateSessionWrapper", e));
        }
      })
      .catch((e) => log("Error from CreateWebLoginforChatWeb ====>", e));
  };

  const handleEmailSentTo = (value) => {
    setEmailSentTo(value);
    setTimeout(() => {
      setEmailSentTo(null);
    }, 2000);
  };
  const handleCreateAccessCode = async (signDetails, accessCodeFlag, flag) => {
    signDetails = signDetails || signUpDetails;
    let reff = accessCodeFlag;
    //Sending Access Code for Both Email & Cellphone
    if (reff === undefined) {
      // if (signDetails["email"].indexOf("@") !== -1) reff = 1;
      // else reff = 2;
      reff = 3;
    }
    log(reff, signDetails["email"], signDetails["cellPhone"]);
    let { GatherId } = signDetails;
    await handleAPI({
      name: "CreateAccessCode",
      params: { GatherId: GatherId, Ref: reff },
    }).then((response) => {
      handleEmailSentTo(reff);
      response = response.split("|");
      if (response.length > 2) {
        let msg = "";
        if (Number(response[3]) === 0) msg = response[1];
        setAccesscodeWarningMsg(msg);
        signDetails = { ...signDetails, AccessCode: response[2] };
        signDetails = { ...signDetails, ...signUpDetails };
        signDetails = { ...signDetails, GatherId: GatherId };
        if (window.parent) {
          window.parent.GatherId = GatherId;
        }
        setSignUpDetails(signDetails);
        setHeaderText(
          "~~~We've sent a code to both your email and cell phone. Enter it below."
        );
        setCurrentpage("accessCode");
        if (flag == -1) {
          if (web) {
            if (window.self !== window.top) {
              try {
                if (window.parent !== null) {
                  if (signDetails["CampaignPage"] === 1) {
                    handleCreateWebLoginforChat(signDetails);
                    return false;
                  }
                }
              } catch (e) {}
              if (loginFrom == "chat") {
                handleCreateWebLoginforChat(signDetails);
                return false;
              }

              if (
                loginFrom == "securedoc" ||
                loginFrom == "loanapp" ||
                loginFrom == "ratequote" ||
                loginFrom == "ratewizard"
              ) {
                handleSaveUseType(true, signDetails);
                return false;
              }
            }
          }
        }
        // return signDetails;
      }
    });
  };
  const validatePassword = (key, text) => {
    setNewPassword({ ...newPassword, [key]: text });
    let strength = 0;
    if (text.length > 6) strength += 1;
    if (text.match(/([A-Z])/) && text.match(/([0-9])/)) strength += 1;
    if (text.match(/([!,%,&,@,#,jQuery,^,*,?,_,~])/)) strength += 1;
    let msg = ``;
    if (strength < 3) {
      msg = `Password does not meet complexity Requirements.`;
    } else {
      msg = `Password Meets Complexity Requirements`;
    }
    if (key === "confirmPassword" && text !== newPassword["password"]) {
      msg = `Password Does Not Match`;
      strength = 0;
    }
    msg = (
      <View>
        <FontAwesome
          name={strength < 3 ? "close" : "check"}
          size={22}
          color={strength < 3 ? "red" : "green"}
        />

        <CustomText
          bold={true}
          style={{
            color: "#999",
            marginTop: -25,
            marginBottom: 20,
            fontSize: 14,
            marginLeft: 30,
          }}
        >
          {msg}
        </CustomText>
      </View>
    );
    setnewPasswordMessage({ ...newPasswordMessage, [`${key}Msg`]: msg });
  };
  const getSecureEmail = () => {
    let Email = "";
    if (
      signUpDetails["email"] === "" ||
      signUpDetails["email"].indexOf("@") === -1
    ) {
      return <></>;
    } else Email = signUpDetails["email"].split("@");
    return (
      <>
        <CustomText
          onPress={() => {
            handleCreateAccessCode(signUpDetails, 1);
          }}
          bold={true}
          style={[styles.footText, { alignSelf: "flex-start", fontSize: 13 }]}
        >
          Resend via email
        </CustomText>
        <CustomText
          bold={true}
          style={{ fontSize: 13, color: "#999", marginTop: 5 }}
        >
          {`${Email[0].slice(0, 2)}...${Email[1]}`}
        </CustomText>
        {[1, 3].includes(emailSentTo) && (
          <CustomText bold={true} style={{ color: "#0000ff", fontSize: 12 }}>
            Sent
          </CustomText>
        )}
      </>
    );
  };
  const getSecurePhone = () => {
    let Phone = signUpDetails["cellPhone"];
    if (Phone === undefined) {
      if (
        Number(signUpDetails["email"]) !== NaN &&
        signUpDetails["email"].indexOf("@") === -1
      ) {
        Phone = signUpDetails["email"];
      }
    } else Phone = Phone.slice(-4);
    return (
      <>
        {Phone === "" ? (
          <></>
        ) : (
          <>
            <CustomText
              onPress={() => {
                handleCreateAccessCode(signUpDetails, 2);
              }}
              bold={true}
              style={[
                styles.footText,
                { alignSelf: "flex-start", fontSize: 13 },
              ]}
            >
              Resend via text message
            </CustomText>
            <CustomText
              bold={true}
              style={{
                fontSize: 13,
                color: "#999",
                marginTop: 5,
                alignSelf:
                  getQueryString("Mobile", "") == "true" ? "flex-end" : "",
              }}
            >
              {`xxx-xxx-${Phone}`}
            </CustomText>
            {[2, 3].includes(emailSentTo) && (
              <CustomText
                bold={true}
                style={{ color: "#0000ff", fontSize: 12 }}
              >
                Sent
              </CustomText>
            )}
          </>
        )}
      </>
    );
  };
  const getHeaderText = () => {
    let header = headerText.split("~~~");
    return (
      <>
        <CustomText bold={true} style={[styles.headText, { color: "#999" }]}>
          {header[0] !== "" ? (
            <CustomText bold={true} style={[styles.headText, { color: "red" }]}>
              {header[0]}
            </CustomText>
          ) : (
            <></>
          )}
          {header[1]}
        </CustomText>
      </>
    );
  };
  const handleUserTypeChange = (name) => {
    let uType = { ...userType, [name]: !userType[name] };
    setUserType(uType);
  };
  useEffect(() => {
    let emailMethod = "DWLogin",
      documentURI = document.documentURI,
      LoanOfficerId = 0,
      device = web ? "desktop" : "mobile",
      prevPage = `${REDIRECT_URL}sitelogin`,
      CampaignPage = 0,
      CampaignInline = "";
    try {
      if (loginFrom === "ratequote") {
        window.parent.document.getElementById("iframeLogin").style.height =
          "600px";
      }
    } catch (error) {}
    if (window.self !== window.top || web) {
      if (
        window.parent.CampaignPage !== null &&
        window.parent.CampaignPage === 1
      )
        CampaignPage = 1;

      CampaignInline = getQueryString("campaigninline", 0);
      try {
        prevPage = window.parent.document.referrer;
      } catch (error) {}
      if (
        documentURI.indexOf("StartLoanApp=1") !== -1 ||
        documentURI.indexOf("To=loanapp") !== -1
      ) {
        emailMethod = "StartLoanApp";
      } else if (documentURI.indexOf("LockThisRate=1") !== -1) {
        emailMethod = "LockThisIntRate";
      } else if (documentURI.indexOf("RateOptions=1") !== -1) {
        emailMethod = "RateOptions";
      } else if (documentURI.indexOf("CustomizeOptions=1") !== -1) {
        emailMethod = "CustomizeOptions";
      } else if (documentURI.indexOf("To=ratequote") !== -1) {
        emailMethod = "RateQuotes";
        LoanOfficerId = window.parent.getQueryString("empnum", "");
      } else if (documentURI.indexOf("To=securedoc") !== -1) {
        emailMethod = "UploadDocs";
        LoanOfficerId = getQuerystring_document("loanofficer=", "0");
      }
    }
    if (
      LoanOfficerId == 0 ||
      LoanOfficerId == null ||
      LoanOfficerId == "" ||
      LoanOfficerId == undefined
    )
      LoanOfficerId = handleGetLoanOfficerId();

    let obj = {
      emailMethod,
      LoanOfficerId,
      device,
      prevPage,
      CampaignPage,
      CampaignInline,
    };
    console.log(obj);
    setSignUpDetails({
      ...signUpDetails,
      ...obj,
    });
    console.log(signUpDetails);
  }, []);
  const handleLogGAEventPasscode = (signDetails) => {
    signDetails = signDetails || signUpDetails;
    let emailMethod =
        signDetails["emailMethod"] || signUpDetails["emailMethos"],
      { LoanOfficerId, WebLoginId, Prevpage, device } = signUpDetails;

    try {
      handleAPI({
        name: "fnLogGAEvent_passcode",
        params: {
          UserWebloginId: WebLoginId,
          device: web ? "desktop" : "mobile",
          LO: LoanOfficerId || 0,
          fromAction: emailMethod || "DWLogin",
          Prevpage: Prevpage || `${REDIRECT_URL}sitelogin`,
        },
      }).then((response) => {
        console.log("fnLogGAEvent_passcode", response);
      });
    } catch (error) {
      console.log(error);
    }
  };
  const getQuerystring_document = (key, default_) => {
    let finalQueryString = "";
    if (default_ == null) default_ = "";
    key = key.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");

    let NewKey = key.toUpperCase();
    NewKey = NewKey.replace("=", "");
    let regex = new RegExp("[\\?&]" + NewKey + "=([^&#]*)"),
      ActualQueryString = window.location.href,
      NewQueryString = ActualQueryString.toUpperCase(),
      qsValue = regex.exec(NewQueryString);
    if (qsValue != null) {
      let startPosi = NewQueryString.indexOf("&" + NewKey),
        keylen = NewKey.length,
        Querylen = ActualQueryString.length,
        prefix = ActualQueryString.substring(0, startPosi),
        sufix = ActualQueryString.substring(startPosi + 1 + keylen, Querylen),
        finalQueryString = prefix + "&" + NewKey + sufix;
    } else {
      finalQueryString = NewQueryString;
    }
    let qs = regex.exec(finalQueryString);
    if (qs == null) return default_;
    else return qs[1];
  };
  const handleLogAutoGAEventPasscode = (signDetails) => {
    let { WebLoginId, device, LoanOfficerId, emailMethod } = {
      ...signDetails,
      ...signUpDetails,
    };
    try {
      handleAPI({
        name: "LogGAEvent",
        params: {
          UserWebloginId: WebLoginId,
          device: web ? "desktop" : "mobile" || "mobile",
          LO: LoanOfficerId || 0,
          fromAction: emailMethod || "DWLogin",
          Prevpage: Prevpage || `${REDIRECT_URL}sitelogin`, //"Mobile Application",
        },
      }).then((response) => {
        console.log("LogGAEvent", response);
      });
    } catch (error) {
      console.log(error);
    }
  };
  const handleSaveUseType = (
    borrowerType,
    signDetails,
    mortgageEmployeeType
  ) => {
    signDetails = signDetails || signUpDetails;
    let { mortgageEmployee, borrower, vendor } = userType,
      userTypeId = 0,
      { GatherId, ShortCode, firstName, lastName } = signDetails;

    if (mortgageEmployee || mortgageEmployeeType) userTypeId += 2;
    if (borrower || borrowerType === true) userTypeId += 1;
    if (vendor) userTypeId += 32;

    if (userTypeId === 0) return false;
    let RateOptions = getQueryString("RateOptions", "0"),
      LockThisRate = getQueryString("LockThisRate", "0"),
      HomePage = getQueryString("HomePage", "0"),
      CustomizeOptions = getQueryString("CustomizeOptions", "0"),
      StartLoanApp = getQueryString("StartLoanApp", "0");
    handleAPI({
      name:
        loginFrom === "siteLogin" ||
        loginFrom === "securedoc" ||
        loginFrom === "esign" ||
        RateOptions == 1 ||
        LockThisRate == 1 ||
        CustomizeOptions == 1 ||
        StartLoanApp == 1
          ? "SaveUserType_WithOutLoan"
          : "SaveUserTypeLogin",
      params:
        loginFrom === "siteLogin" ||
        loginFrom === "securedoc" ||
        loginFrom === "esign" ||
        RateOptions == 1 ||
        LockThisRate == 1 ||
        CustomizeOptions == 1 ||
        StartLoanApp == 1
          ? {
              UserType: userTypeId,
              WebLoginId: GatherId,
            }
          : {
              fieldval: userTypeId,
              GatherDataId: GatherId,
              ShortCode: "",
              blremove: "0",
            },
    }).then((response) => {
      if (borrowerType === true) {
        handleBorrowerLogin(true, signDetails);
      } else {
        handleNextToLogin(signDetails);
      }
    });
  };

  const handleNextToLogin = (signDetails) => {
    let { GatherId, ShortCode } = signDetails;
    handleAPI({
      name: "CheckUserTypeSelected",
      params: {
        GatherId: GatherId,
        ShortCode: ShortCode,
      },
    }).then((UserTypeSelected) => {
      UserTypeSelected = JSON.parse(UserTypeSelected);
      signDetails["UserType"] = UserTypeSelected;
      if (parseInt(UserTypeSelected) === 1) {
        if (loginFrom === "siteLogin") {
          handleAPI({
            name: "CreateBorrowerLoginWithNoLoanId",
            params: {
              ShortCode: ShortCode,
              GatherId: GatherId,
            },
          }).then((response) => {
            response = response.split("~");
            let Loanid = response[1],
              WebLoginId = response[2],
              SessionId = response[3];
            let url = "";
            let StartLoanApp = Number(getQueryString("StartLoanApp", "0") || 0);
            if (StartLoanApp == 1) {
              url = `${window.location.origin}/GoDirect/index.html?Path=Home&SessionId=${SessionId}&loanId=-999`;
            } else {
              url = `${window.location.origin}/GoDirect/index.html?Path=DashBoard&SessionId=${SessionId}`;
            }
            signDetails = {
              ...signDetails,
              ...{
                Loanid: Loanid,
                WebLoginId: WebLoginId,
                SessionId: SessionId,
                URL: url,
              },
            };

            setSignUpDetails(signDetails);
            if (isRemember) {
              handleSetStoredCredential(signDetails);
              handleLogAutoGAEventPasscode(signDetails);
              handleAPI({
                name: "SaveDeviceFingerPrintWebForGatherId",
                params: {
                  GatherId: GatherId,
                  DeviceId: deviceId,
                  SaveResp: 1,
                },
              }).then((response) => {});
            } else {
              handleLogGAEventPasscode(signDetails);
            }
            // navigation.navigate("DashBoard", {
            //   userName: `${firstName} ${lastName}`,
            //   SessionId: SessionId,
            // });
            if (loginFrom === "siteLogin") {
              try {
                window.parent.location.href = url;
              } catch (e) {
                window.location.href = url;
              }
            }
            handleClearState();
          });
        } else {
          handleBorrowerLogin(false, signDetails);
        }
      } else {
        handleLogGAEventEmployee(signDetails);
      }
    });
  };
  const handleLogGAEventEmployee = (signDetails) => {
    let emailMethod = signDetails["emailMethod"] || "DWLogin",
      {
        device,
        LoanOfficerId,
        prevPage,
        GatherId,
        WebLoginId = "",
        SessionId = "",
        ShortCode,
      } = signDetails;

    handleAPI({
      name: "fnLogGAEvent_passcode_Employee",
      params: {
        UserWebloginId: GatherId,
        device: web ? "desktop" : "mobile",
        IpAddress: deviceId,
        LO: LoanOfficerId,
        fromAction: emailMethod,
        Prevpage: prevPage,
      },
    })
      .then(async (response) => {
        if (web) {
          if (loginFrom === "RunScenario") {
            const objLoginParams = { SessionId };
            try {
              window.parent.fnStoreQueryParams(objLoginParams);
            } catch (error) {
              window.top.fnStoreQueryParams(objLoginParams);
            }
          }

          let URL = `../../../Login/Presentation/Webforms/AccountSetupInformation.aspx?SessionID=${SessionId}&WID=${WebLoginId}&GatherId=${GatherId}&ShortCode=${ShortCode}&Route=${
            Route || loginFrom
          }`;

          try {
            window.parent.location = URL;
          } catch (e) {
            window.location = URL;
          }
        } else {
          setWebPageURL(
            `../../../Login/Presentation/Webforms/AccountSetupInformation.aspx?SessionID=${SessionId}&WID=${WebLoginId}&GatherId=${GatherId}&ShortCode=${ShortCode}&Route=${loginFrom}`
          );
          setTimeout(() => {
            navigate("Login", { userName: userName });
          }, 1500);
          handleClearState();
        }
      })
      .catch((e) => log("Error form ====>", e));
  };

  const handleCreateSession = async (WebLoginId) => {
    await handleAPI({
      name: "CreateSessionWrapper",
      params: { WebLoginId: WebLoginId },
    }).then((response) => {
      response = response.split("~");
      return response[0];
    });
  };

  const handleBorrowerLogin = (isBorr, signDetails) => {
    handleAPI({
      name: "CheckLoanOfficer_alreadyselected_Web",
      params: {
        GatherId: signDetails["GatherId"],
        ShortCode: signDetails["ShortCode"] || 0,
      },
    })
      .then((response) => {
        let arr = response.split("~"),
          urlToGo = "",
          loanId = arr[1],
          WebLoginId = arr[2],
          SessionId = arr[3];
        let StartLoanApp = getQueryString("StartLoanApp", "0");
        if (isBorr) {
          //urlToGo = `../../../BorrowerLanding/Presentation/Webforms/BorrowerWelcome.aspx?SessionId=${SessionId}&To=${loginFrom}`;

          urlToGo = `${window.location.origin}/GoDirect/index.html?Path=DashBoard&SessionId=${SessionId}`;

          if (StartLoanApp == 1) {
            urlToGo = `${window.location.origin}/GoDirect/index.html?Path=Home&SessionId=${SessionId}&loanId=-999`;
          } else {
            urlToGo = navigateURL("DashBoard", params, SessionId);
          }

          if (
            (loginFrom == "loanapp" || loginFrom == "ratewizard") &&
            loanId > 0
          ) {
            urlToGo += `&loanId=${loanId}`;
          }

          if (StartLoanApp == 1) {
            urlToGo += "&StartLoanApp=1";
            urlToGo += "&loanOfficerId=" + signUpDetails["LoanOfficerId"];
          }

          if (loginFrom == "ratewizard" || loginFrom == "loanapp")
            handleAssociateLoanId(SessionId, urlToGo);

          if (loginFrom == "ratequote") {
            return;
          }
        } else {
          handleLogGAEventPasscode(signUpDetails);
          //urlToGo = `../../../BorrowerLanding/Presentation/Webforms/BorrowerWelcome.aspx?SessionId=${SessionId}&To=${loginFrom}`;

          urlToGo = `${window.location.origin}/GoDirect/index.html?Path=DashBoard&SessionId=${SessionId}`;
          urlToGo += "&loanOfficerId=" + signUpDetails["LoanOfficerId"];
          if (
            signUpDetails["LoanOfficerId"] == 1 ||
            signUpDetails["LoanOfficerId"] == 2099
          ) {
            //navigate("DashBoard", params);
            if (loginFrom === "securedoc") {
              let PublicPage = getQueryString("Publicpage", "");
              urlToGo = navigateURL("Home", params, SessionId);
              if (PublicPage == "1" && loanId > 0) {
                urlToGo += "&GoToNav=9&PublicPage=1";
              }
            } else urlToGo = navigateURL("DashBoard", params, SessionId);
          }

          if (loginFrom === "loanapp" && loanId > 0)
            urlToGo += `&loanid=${loanId}`;
          urlToGo += "&loanOfficerId=" + signUpDetails["LoanOfficerId"];
          loginFrom !== "securedoc";
          handleAssociateLoanId(SessionId, urlToGo);
        }
        setSignUpDetails({
          ...signUpDetails,
          ...signDetails,
          ...{
            loanId,
            WebLoginId,
            SessionId,
            URL: urlToGo,
            UserType: "C",
          },
        });
        if (loginFrom === "siteLogin") {
          try {
            window.parent.location.href = urlToGo;
          } catch (e) {
            window.location.href = urlToGo;
          }
        }
      })
      .catch((e) =>
        log("Error from CheckLoanOfficer_alreadyselected_Web ====>", e)
      );
  };
  const handleAssociateLoanId = (SessionId, NextURL) => {
    let Loginmethod = "";
    if (NextURL.indexOf("To=securedoc") !== -1) Loginmethod = "UploadDocs";

    if (NextURL.indexOf("To=ratewizard") !== -1) {
      if (document.documentURI.indexOf("CustomizeOptions=1") !== -1) {
        Loginmethod = "CustomizeOptions";
      } else Loginmethod = "LockThisIntRate";
    }
    let LoanId = getQueryStringURL("LoanId", "", NextURL);
    if (LoanId == "" || Loginmethod == "") return;

    handleAPI({
      name: "AssociateLoanId_GA",
      params: {
        SessionId: SessionId,
        LoanId: LoanId,
        LoginMethod: Loginmethod,
      },
    })
      .then((response) => {})
      .catch((e) => log("Error from ====>", e));
  };
  // const handleStoreCampaignDetails = () => {
  //   try {
  //     handleAPI({
  //       name: "StoreUTMCampaignWithOutLoginId",
  //       params: {
  //         CampignId: "118",
  //         WebLoginId: 4142, //signUpDetails["WebLoginId"],
  //         utmsource: "Direct Mortgage",
  //         utmmedium: "Internal",
  //         utmcampaign: "Login Creation",
  //         utmcontent: "",
  //         utmterm: "",
  //         OrgUrl: `${REDIRECT_URL}sitelogin`,
  //         MsgText: "",
  //         Email: signUpDetails["email"],
  //         Phone: signUpDetails["cellPhone"],
  //         CampignNum: 0,
  //         LeadOfficer: 0,
  //       },
  //     }).then((response) => {
  //       console.log("StoreUTMCampaignWithOutLoginId", response);
  //     });
  //   } catch (e) {
  //     console.error(e);
  //   }
  // };
  const handleUpdateUserEmailInCTA = async (EmailId) => {
    let DeviceId =
        window?.parent?.GloParentDeviceId ||
        (await AsyncStorage.getItem("DeviceId")) ||
        null,
      PageLoadId =
        window?.parent?.GLO_PageLoadId ||
        (await AsyncStorage.getItem("PageLoadId")) ||
        null,
      Buttontext = handleGetButtonText(loginFrom);
    handleAPI({
      name: "UpdateUserEmailInCTA",
      params: {
        Buttontext,
        PageLoadId,
        EmailId,
        DeviceId,
      },
    }).then((response) => {});
  };
  const handleLogDWCallToActionEventParent = async (iButtontext) => {
    try {
      let device = web ? "desktop" : "mobile",
        Buttontext = "",
        documentURI = document.documentURI;

      if (
        documentURI.includes("StartLoanApp=1") ||
        documentURI.includes("To=loanapp")
      )
        Buttontext = "Start a Loan Application";
      else if (documentURI.includes("LockThisRate=1"))
        Buttontext = "Lock This Interest Rate";
      else if (documentURI.includes("RateOptions=1"))
        Buttontext = "View All Fees and Rate Options";
      else if (documentURI.includes("CustomizeOptions=1"))
        Buttontext = "Customize Your Scenario";
      else if (documentURI.includes("To=ratequote")) Buttontext = "Rate Quote";
      else if (documentURI.includes("To=securedoc"))
        Buttontext = "Upload Documents";
      else if (documentURI.includes("To=ratewizard&RateQuoteId=undefined"))
        Buttontext = "Track these Rates";
      else if (loginFrom === "securedoc") Buttontext = "Upload Documents";
      else if (loginFrom === "loanapp") Buttontext = "Apply Online";

      if (iButtontext) Buttontext = iButtontext;

      let params = {
        PageTitle: window.parent?.document.title,
        PageURL: window.parent?.location.href,
        device,
        IPAddress: window.parent?.GloParentDeviceId || "",
        ParentId: window.parent?.GLO_PageLoadId || "",
        Buttontext,
        detailsJson: JSON.stringify([
          {
            Browser: handleGetBrowserName(),
            LoanId: 0,
            LoanOfficerId: web
              ? queryStringToObject(window.location?.href || "")[
                  "loanOfficerId"
                ] ||
                contextDetails.RecentLoId ||
                0
              : contextDetails.RecentLoId || 0,
            Email: signUpDetails["email"] || "",
          },
        ]),
      };
      AsyncStorage.setItem(
        "PageLoadId",
        window?.parent?.GLO_PageLoadId || null
      );
      if (Buttontext !== "") {
        handleAPI({
          name: "fnLogDWCallToActionEvent",
          params,
        })
          .then((response) => {
            handleTrackGA4Events(Buttontext, params);
          })
          .catch((e) => log("Error form fnLogDWCallToActionEvent ====> ", e));
      }
    } catch (error) {}
  };
  const handleStoreCampaignDetails = async (
    CampignId,
    utm_campaign,
    CampignNum
  ) => {
    try {
      let OrgUrl = web
          ? window.top.document.location.href
          : `${REDIRECT_URL}sitelogin`,
        { LoanOfficerId, cellPhone, email, WebLoginId } = signUpDetails;
      AsyncStorage.removeItem("CampaignDetails");
      AsyncStorage.setItem(
        "CampaignDetails",
        JSON.stringify({ CampignId, utm_campaign, CampignNum, WebLoginId }) ||
          null
      );
      if (OrgUrl) OrgUrl = "";
      handleLogDWCallToActionEventParent();
      await handleAPI({
        name: "StoreUTMCampaignWithOutLoginId",
        params: {
          ...{
            CampignId: CampignId || "118",
            WebLoginId: WebLoginId || 4142,
            utmsource: "Direct Mortgage",
            utmmedium: "Internal",
            utmcampaign: utm_campaign || "Login Creation",
            utmcontent: "",
            utmterm: "",
            OrgUrl: OrgUrl,
            MsgText: "",
            Email: email,
            Phone: cellPhone,
          },
          ...(CampignNum !== -1 && {
            CampignNum: CampignNum || 0,
            LeadOfficer: LoanOfficerId,
          }),
        },
      }).then((response) => {
        console.log("StoreUTMCampaignWithOutLoginId", response);
      });
    } catch (e) {
      console.error(e);
    }
  };
  //========================================
  return (
    <>
      {webPageURL ? (
        <>
          <webPageView url={webPageURL} />
        </>
      ) : (
        <View
          style={[
            {
              backgroundColor:
                getQueryString("Route", "") === "dmloanapp"
                  ? "#f4f4f4"
                  : "#fff",
              flex: 1,
            },
            // loginFrom === "esign" && {
            //   alignItems: "center",
            //   width: window.innerWidth,
            // },
          ]}
        >
          {(loginFrom === "esign" || loginFrom === "chat") && (
            <View
              style={{
                width: "100%",
                height: 85,
                boxShadow: "0 0 3px 0 rgba(0,0,0,0.22)",
                marginBottom: loginFrom === "esign" ? 50 : 20,
                display: getQueryString("HideHeader", "") === "1" ? "none" : "",
              }}
            >
              <Image
                style={{
                  position: "relative",
                  height: "50px",
                  width: "180px",
                  marginTop: 25,
                  marginBottom: 10,
                  marginLeft: 30,
                }}
                source={require("../../assets/logo.png")}
              />
              {loginFrom === "esign" && (
                <CustomText
                  bold={true}
                  style={{
                    color: "#999",
                    fontSize: isMobileWeb ? 21 : 27,
                    marginTop: 15,
                    marginBottom: 10,
                    marginLeft: 15,
                  }}
                >
                  Welcome to the E-Signature Page
                </CustomText>
              )}
            </View>
          )}
          <View
            style={[
              {
                // width: !web
                //   ? null
                //   : getQueryString("Route", "") === "dmloanapp"
                //   ? "95%"
                //   : "inherit",
                width: "95vw",
              },
              web ? { maxWidth: 475 } : {},
            ]}
          >
            <ScrollContainer>
              <View
                style={[
                  styles.container,
                  // loginFrom === "esign"
                  //   ? {
                  //       boxShadow: "0 5px 15px rgba(0,0,0,.5)",
                  //       border: "1px solid #999",
                  //       marginTop: 10,
                  //       marginLeft: 15,
                  //       marginRight: 25,
                  //       marginBottom: 25,
                  //       width: "92%",
                  //     }
                  //   : {},
                  { marginLeft: loginFrom === "loanapp" ? "1rem" : "" },
                ]}
              >
                <View style={styles.headContainer}>{getHeaderText()}</View>
                <View style={styles.body}>
                  {currentPage === "signUp" && (
                    <>
                      <InputBox
                        label="First Name"
                        placeholder="First Name"
                        onChangeText={(text) =>
                          handleChange({ name: "firstName", value: text })
                        }
                        autoFocus
                        value={signUpDetails["firstName"]}
                        validate={validateSignUp["firstName"]}
                      />
                      <InputBox
                        label="Last Name"
                        placeholder="Last Name"
                        onChangeText={(text) =>
                          handleChange({ name: "lastName", value: text })
                        }
                        value={signUpDetails["lastName"]}
                        validate={validateSignUp["lastName"]}
                      />
                      <InputBox
                        keyboardType="numeric"
                        label="Cell Phone Number"
                        placeholder="Cell Phone Number"
                        onChangeText={(text) =>
                          handleChange({ name: "cellPhone", value: text })
                        }
                        onBlur={() => {
                          handleChange({
                            name: "formatedCellPhone",
                            value: signUpDetails["cellPhone"],
                            isFormat: true,
                          });
                        }}
                        value={signUpDetails["formatedCellPhone"]}
                        validate={validateSignUp["cellPhone"]}
                      />
                      <InputBox
                        label="Email Address"
                        placeholder="Email address"
                        onChangeText={(text) =>
                          handleChange({ name: "email", value: text })
                        }
                        onKeyPress={(event) => {
                          if (event.nativeEvent.key === "Enter") {
                            handleSubmit();
                          }
                        }}
                        value={signUpDetails["email"]}
                        validate={validateSignUp["email"]}
                      />
                      {errorMsg["text"] && (
                        <View>
                          <CustomText
                            bold={true}
                            style={{
                              color: errorMsg["color"] || "red",
                              fontSize: 15,
                              marginTop: 15,
                            }}
                          >
                            {errorMsg["text"]}
                          </CustomText>
                        </View>
                      )}
                      <IconButton
                        title="Submit"
                        style={{
                          alignSelf: "flex-end",
                        }}
                        onPress={handleSubmit}
                        loading={processingStatus === "Submit"}
                        sStyle={{
                          minWidth: 30,
                          height: 15,
                        }}
                      />
                    </>
                  )}
                  {currentPage === "accessCode" && (
                    <>
                      <InputBox
                        label="Access Code"
                        autoFocus
                        keyboardType="numeric"
                        placeholder="Please enter your access code..."
                        onChangeText={(text) => {
                          handleChange({
                            name: "enteredAccessCode",
                            value: text,
                          });
                          if (errorMsg["text"] !== "")
                            setErrormsg({ ...errorMsg, text: "" });
                        }}
                        onKeyPress={(event) => {
                          if (event.nativeEvent.key === "Enter") {
                            if (signUpDetails["enteredAccessCode"] !== "")
                              handleValidateAccessCode();
                          }
                        }}
                        value={signUpDetails["enteredAccessCode"]}
                      />
                      {errorMsg["text"] && (
                        <View>
                          <CustomText
                            bold={true}
                            style={{
                              color: errorMsg["color"] || "red",
                              fontSize: 15,
                              marginTop: -5,
                              marginBottom: 15,
                            }}
                          >
                            {errorMsg["text"]}
                          </CustomText>
                        </View>
                      )}
                      {/* <IconButton
                        style={{
                          marginTop: -5,
                        }}
                        onPress={handleValidateAccessCode}
                        icon={false}
                        title="Validate Access Code"
                      /> */}
                      <View
                        style={{
                          margin: "10px 0px",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <View style={{ flexDirection: "row" }}>
                          <Checkbox
                            value={isRemember}
                            onValueChange={() => {
                              setIsRemember(!isRemember);
                            }}
                            color={isRemember ? "#0075ff" : undefined}
                          />
                          <View style={{ flexDirection: "column" }}>
                            <CustomText
                              bold={true}
                              style={{
                                color: "#999",
                                fontSize: 15,
                                marginLeft: 10,
                              }}
                              onPress={() => {
                                setIsRemember(!isRemember);
                              }}
                            >
                              Remember me on this device
                              {web && (
                                <CustomText
                                  style={{ fontSize: 12, color: "#999" }}
                                  bold={true}
                                  italic={true}
                                >
                                  {"\n"}(not recommended on public computers)
                                </CustomText>
                              )}
                            </CustomText>
                          </View>
                        </View>
                        <IconButton
                          style={{
                            marginTop: -5,
                          }}
                          onPress={handleValidateAccessCode}
                          icon={false}
                          title="Validate Code"
                          loading={processingStatus === "validating"}
                          sStyle={{
                            minWidth: 30,
                            height: 15,
                          }}
                        />
                      </View>

                      <View style={{ margin: 10 }}>
                        <View
                          style={{
                            borderBottomColor: "black",
                            borderBottomWidth: 1,
                            marginTop: 20,
                          }}
                        />
                        <View
                          style={{
                            marginTop: 30,
                            marginBottom: 20,
                          }}
                        >
                          {accesscodeWarningMsg && (
                            <CustomText
                              style={{
                                fontSize: 16,
                                color: "#999",
                                marginBottom: 15,
                                marginTop: -15,
                              }}
                              bold={true}
                            >
                              {accesscodeWarningMsg}
                            </CustomText>
                          )}
                          <CustomText
                            style={{
                              fontSize: 17,
                              color: "#999",
                              marginBottom: 15,
                            }}
                            bold={true}
                          >
                            Didn't get the code?
                          </CustomText>
                          <View
                            style={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <View>{getSecureEmail()}</View>
                            <View>{getSecurePhone()}</View>
                          </View>
                        </View>
                      </View>
                    </>
                  )}
                  {currentPage === "loginOption" && (
                    <>
                      <View
                        style={{
                          flexDirection: "row",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <View>
                          <IconButton
                            loading={processingStatus === "loginNow"}
                            sStyle={{
                              minWidth: 30,
                              height: 15,
                            }}
                            onPress={() => {
                              if (loginFrom === "esign") {
                                setHeaderText(
                                  "~~~Please select the type of user account that you will be using:"
                                );
                                setCurrentpage("userType");
                              } else {
                                setProcessingStatus("loginNow");
                                handleSaveUseType(false, signUpDetails, true);
                              }
                            }}
                            title="Login Now"
                          />
                        </View>
                        <View
                          style={{
                            flexDirection: "row",
                          }}
                        >
                          <IconButton
                            loading={processingStatus === "loginNow"}
                            sStyle={{
                              minWidth: 30,
                              height: 15,
                            }}
                            style={{ marginLeft: 10 }}
                            onPress={() => {
                              setHeaderText("~~~Set a password");
                              setCurrentpage("setPassword");
                            }}
                            title="Set Password"
                            buttonType="secondary"
                          />
                        </View>
                      </View>
                    </>
                  )}
                  {currentPage === "setPassword" && (
                    <View>
                      <CustomText
                        //  bold={true}
                        style={{
                          fontSize: 16,
                          color: "#999",
                          marginBottom: 20,
                        }}
                      >
                        {`Please create your password below: 

Password Requirments: 
Minimum length of 6 characters, 1 number, 1 capital letter, and 1 special character such as: (@!*&).`}
                      </CustomText>
                      <View>
                        <View>
                          <InputBox
                            label="Password"
                            autoFocus
                            secureTextEntry={newIsPasswordSecure["password"]}
                            placeholder="Please enter your password..."
                            onChangeText={(text) => {
                              validatePassword("password", text);
                            }}
                            value={newPassword["password"]}
                          />

                          <CustomText
                            style={{ position: "absolute", right: 20, top: 20 }}
                            onPress={() => {
                              setNewIsPasswordSecure({
                                ...newIsPasswordSecure,
                                password: !newIsPasswordSecure["password"],
                              });
                            }}
                          >
                            {newIsPasswordSecure["password"] ? (
                              <FontAwesome name="eye" color="gray" size={15} />
                            ) : (
                              <FontAwesome
                                name="eye-slash"
                                color="gray"
                                size={15}
                              />
                            )}
                          </CustomText>

                          {newPasswordMessage["passwordMsg"] !== "" &&
                            newPassword["password"] !== "" && (
                              <>{newPasswordMessage["passwordMsg"]}</>
                            )}
                        </View>
                        <View>
                          <InputBox
                            label="Confirm Password"
                            secureTextEntry={
                              newIsPasswordSecure["confirmPassword"]
                            }
                            placeholder="Confirm your password..."
                            onChangeText={(text) => {
                              validatePassword("confirmPassword", text);
                            }}
                            value={newPassword["confirmPassword"]}
                          />
                          <CustomText
                            style={{ position: "absolute", right: 20, top: 20 }}
                            onPress={() => {
                              setNewIsPasswordSecure({
                                ...newIsPasswordSecure,
                                confirmPassword:
                                  !newIsPasswordSecure["confirmPassword"],
                              });
                            }}
                          >
                            {newIsPasswordSecure["confirmPassword"] ? (
                              <FontAwesome name="eye" color="gray" size={15} />
                            ) : (
                              <FontAwesome
                                name="eye-slash"
                                color="gray"
                                size={15}
                              />
                            )}
                          </CustomText>

                          {newPasswordMessage["confirmPasswordMsg"] !== "" &&
                            newPassword["confirmPassword"] !== "" && (
                              <>{newPasswordMessage["confirmPasswordMsg"]}</>
                            )}
                        </View>
                        <View style={{ marginBottom: 20 }}>
                          <IconButton
                            loading={processingStatus === "Save&Login"}
                            sStyle={{
                              minWidth: 30,
                              height: 15,
                            }}
                            onPress={() => {
                              if (newPassword["password"] === "") {
                                setPasswordMisMatch(
                                  "Please enter the New Password."
                                );
                                return false;
                              }
                              if (newPassword["confirmPassword"] === "") {
                                setPasswordMisMatch(
                                  "Please enter the Confirm New Password."
                                );
                                return false;
                              }
                              if (
                                newPassword["confirmPassword"] !==
                                newPassword["password"]
                              ) {
                                setPasswordMisMatch(
                                  "The new password and confirmed password do not match."
                                );
                                return false;
                              }

                              let strength = 0,
                                text = newPassword["password"];
                              if (text.length > 6) strength += 1;
                              if (
                                text.match(/([A-Z])/) &&
                                text.match(/([0-9])/)
                              )
                                strength += 1;
                              if (text.match(/([!,%,&,@,#,jQuery,^,*,?,_,~])/))
                                strength += 1;
                              if (strength < 3) {
                                setPasswordMisMatch(
                                  `Password does not meet minimum complexity requirements, password must contain: 
  Minimum length of 6 characters 
  Must contain 1 number, 1 capital letter, and 1 special character such as: (@!*&)`
                                );
                                return false;
                              }
                              strength = 0;
                              text = newPassword["confirmPassword"];
                              if (text.length > 6) strength += 1;
                              if (
                                text.match(/([A-Z])/) &&
                                text.match(/([0-9])/)
                              )
                                strength += 1;
                              if (text.match(/([!,%,&,@,#,jQuery,^,*,?,_,~])/))
                                strength += 1;
                              if (strength < 3) {
                                setPasswordMisMatch(
                                  `Password does not meet minimum complexity requirements, password must contain: 
  Minimum length of 6 characters 
  Must contain 1 number, 1 capital letter, and 1 special character such as: (@!*&)`
                                );
                                return false;
                              }

                              if (
                                newPassword["password"] ===
                                newPassword["confirmPassword"]
                              ) {
                                setProcessingStatus("Save&Login");
                                let { GatherId, email, ShortCode } =
                                  signUpDetails;
                                handleAPI({
                                  name: "UpdatePasswordinGatherdata",
                                  params: {
                                    GatherId: GatherId,
                                    UserName: email,
                                    Password: newPassword["password"],
                                    // shortCode: ShortCode,
                                  },
                                })
                                  .then((response) => {
                                    if (loginFrom === "esign") {
                                      setHeaderText(
                                        "~~~Please select the type of user account that you will be using:"
                                      );
                                      setCurrentpage("userType");
                                    } else {
                                      handleSaveUseType(
                                        false,
                                        signUpDetails,
                                        true
                                      );
                                    }
                                  })
                                  .catch((err) =>
                                    console.log(
                                      "Errorm from ====> UpdatePasswordinGatherdata",
                                      err
                                    )
                                  );
                              }
                            }}
                            title="Save & Login"
                          />
                        </View>

                        {PasswordMisMatch !== "" && (
                          <View
                            style={{
                              backgroundColor: "#f2dede",
                              borderColor: "#ebccd1",
                              borderRadius: 4,
                              borderWidth: 1,
                              padding: 10,
                              marginTop: 10,
                            }}
                          >
                            <CustomText bold={true} style={{ color: "#999" }}>
                              {PasswordMisMatch}
                            </CustomText>
                          </View>
                        )}
                      </View>
                    </View>
                  )}
                  {currentPage === "ContactMethod" && (
                    <>
                      <View style={{ width: "50%" }}>
                        {["Email", "Text", "Phone Call"].map((item, index) => (
                          <TouchableOpacity
                            activeOpacity={1}
                            onPress={() => {
                              setSignUpDetails({
                                ...signUpDetails,
                                ContactMethod: index,
                              });
                            }}
                            style={styles.optionContainer}
                          >
                            {signUpDetails["ContactMethod"] === index && (
                              <FontAwesome
                                name="check"
                                size={22}
                                color="green"
                              />
                            )}
                            <CustomText style={styles.optionText}>
                              {item}
                            </CustomText>
                          </TouchableOpacity>
                        ))}
                      </View>
                      <View style={{ flexDirection: "row" }}>
                        <IconButton
                          title="Submit"
                          onPress={() => {
                            handleAPI({
                              name: "SavePreferredContactMethodForLogin",
                              params: {
                                GatherdataId: signUpDetails["GatherId"],
                                ContactMethod: signUpDetails["ContactMethod"],
                              },
                            })
                              .then((response) => {
                                handleCreateAccessCode();
                              })
                              .catch((e) =>
                                log(
                                  "Error from SavePreferredContactMethodForLogin ===> ",
                                  e
                                )
                              );
                          }}
                        />
                        <IconButton
                          style={{ marginLeft: 10 }}
                          title="Back"
                          onPress={() => {
                            handleClearState(0);
                          }}
                        />
                      </View>
                    </>
                  )}
                  {currentPage === "userType" && (
                    <>
                      <View>
                        <View>
                          <View style={{ width: "80%" }}>
                            <TouchableOpacity
                              activeOpacity={1}
                              onPress={() => {
                                handleUserTypeChange("mortgageEmployee");
                              }}
                              style={styles.optionContainer}
                            >
                              {userType["mortgageEmployee"] && (
                                <FontAwesome
                                  name="check"
                                  size={22}
                                  color="green"
                                />
                              )}
                              <CustomText bold={true} style={styles.optionText}>
                                {loginFrom === "esign"
                                  ? "Loan Officer"
                                  : "Mortgage Employee"}
                              </CustomText>
                            </TouchableOpacity>
                            <TouchableOpacity
                              activeOpacity={1}
                              onPress={() => {
                                handleUserTypeChange("borrower");
                              }}
                              style={styles.optionContainer}
                            >
                              {userType["borrower"] && (
                                <FontAwesome
                                  name="check"
                                  size={22}
                                  color="green"
                                />
                              )}
                              <CustomText bold={true} style={styles.optionText}>
                                Borrower
                              </CustomText>
                            </TouchableOpacity>
                            <TouchableOpacity
                              activeOpacity={1}
                              onPress={() => {
                                handleUserTypeChange("vendor");
                              }}
                              style={styles.optionContainer}
                            >
                              {userType["vendor"] && (
                                <FontAwesome
                                  name="check"
                                  size={22}
                                  color="green"
                                />
                              )}
                              <CustomText bold={true} style={styles.optionText}>
                                {loginFrom === "esign"
                                  ? "Escrow Agent"
                                  : "Vendor"}
                              </CustomText>
                            </TouchableOpacity>
                          </View>
                        </View>
                        <IconButton
                          onPress={handleSaveUseType}
                          title="Continue"
                        />
                      </View>
                    </>
                  )}
                </View>
                <View style={styles.footContainer}>
                  <CustomText
                    bold={true}
                    onPress={(e) => {
                      navigation.navigate("Login", { reset: true });
                      // updateWebURL();
                    }}
                    style={[
                      styles.footText,
                      { textDecorationLine: "none", borderWidth: 0 },
                    ]}
                  >
                    {/* <Icon name="arrowleft" size={15} color="#999" /> */}←
                    Back
                  </CustomText>
                  {loginFrom === "siteLogin" && currentPage === "emailOnly" && (
                    <CustomText
                      bold={true}
                      onPress={(e) => {
                        navigation.navigate("Login", { reset: true });
                      }}
                      style={styles.footText}
                    >
                      Forgot Password
                    </CustomText>
                  )}
                </View>
              </View>
            </ScrollContainer>
          </View>
        </View>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    ...{
      color: "#333",
      backgroundColor: "#f5f5f5",
      borderWidth: 1,
      borderColor: "#ddd",
      borderRadius: 5,
      margin: 5,
      //width: isIOS || isAndroid ? "80%" : "96%",
      width: "96%",
    },
    // ...(web ? { width: 450 } : {}),
  },
  flex: {
    flex: 1,
  },
  optionContainer: {
    // elevation: 8,
    borderRadius: 15,
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderColor: "#606060",
    borderWidth: 1,
    marginBottom: 20,
    flexDirection: "row",
  },
  optionText: {
    width: "100%",
    color: "#999",
    fontSize: 23,
    textAlign: "center",
    flex: 1,
    flexShrink: 1,
  },
  body: {
    display: "flex",
    backgroundColor: "#fff",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#ddd",
    paddingTop: 25,
    paddingBottom: 20,
    paddingHorizontal: 10,
  },
  textBox: {
    width: "90%",
    // height: 65,
    flexDirection: "row",
    marginLeft: 10,
    fontSize: 5,
  },
  footContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 10,
  },
  headContainer: {
    paddingTop: 25,
    paddingBottom: 10,
    paddingRight: 25,
    paddingLeft: 25,
  },

  footText: {
    fontSize: 13,
    color: "#999",
    textDecorationLine: android ? "none" : "underline",
    borderBottomWidth: android ? 1 : 0,
    borderBottomColor: "#999",
  },
  headText: {
    fontSize: 18,
    color: "#999",
  },
});
export default Signup;
